module.exports = __webpack_public_path__ + "img/eazis-pulse-white.f735e12b.png";